exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-range-progress[data-v-81d9fd82]:after{content:var(--time);font-size:12px;position:absolute;top:100%;transform:translate(-50%,50%);left:var(--left);opacity:.65}.loading_circle[data-v-81d9fd82]{width:48px;height:48px}.pause_circle[data-v-81d9fd82]{font-size:38px}.ic-forward-replay[data-v-81d9fd82]{width:24px;height:24px}@media screen and (max-width:768px){.loading_circle[data-v-81d9fd82]{width:64px;height:64px}.pause_circle[data-v-81d9fd82]{font-size:48px}.ic-forward-replay[data-v-81d9fd82]{width:32px;height:32px}}", ""]);

// exports
